import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskKbRequestsReportsTimeScaleRoute: InvariantJiraRoute = {
	name: 'servicedesk-kb-requests-reports-time-scale',
	path: '/jira/servicedesk/projects/:projectKey/reports/:reportId(kb-requests-resolved|kb-requests-deflected)/timescale/:timescaleId',
};
